<template>
  <BreadCrumb :PageTitle="t('breadCrumb.myAccount')" />
  <CoverImage />
  <AccountSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import CoverImage from "../../components/Settings/CoverImage.vue";
import AccountSettings from "../../components/Settings/AccountSettings/AccountSettings.vue";

export default defineComponent({
  name: "AccountSettingsPage",
  components: {
    BreadCrumb,
    CoverImage,
    AccountSettings,
  },
  setup() {
      const { t } = useI18n();
      return {
      t,
    };
  }
});
</script>